import React, { Component } from "react";

export default class Cell extends Component {
  render() {
    let elementClass = "col d-flex justify-content-center align-items-center";
    let myStyle = {
      background: "white",
      fontSize: 20 + "px",
      cursor: "pointer",
      color: "#333",
    }
    if (this.props.cell.animation) {
      if (this.props.cell.animation === 'textBlink') {
        myStyle = {
          ...myStyle,
          animation: 'textBlink',
          animationDuration: '2s',
          animationIterationCount: 1000
        }
      } else {
        myStyle = {
          ...myStyle,
          animation: this.props.cell.animation + ' 1s'
        }
      }
    }
    return (
      <div
        className={elementClass}
        onClick={this.props.onCellClick}
        style={myStyle}
      >
        <span className=''>{this.props.cell.value}</span>
      </div>
    );
  }
}
